export default __webpack_public_path__ + "static/media/players-mob.c96a1286.png";